<template>
  <div v-on-clickaway="closeSelector" class="relative">
    <button
      class="nav-action-item flex items-center gap-1 p-1 rounded-[5px] hover:bg-gray-100 transition-colors shrink-0 cursor-pointer outline-none border-0 bg-transparent"
      @click="toggleSelector"
    >
      <div class="flex items-center gap-[5px]">
        <span
          class="material-symbols-outlined text-[16px] text-gray-600 leading-none"
        >
          group
        </span>
        <span class="text-sm text-gray-600 leading-5 whitespace-nowrap">
          {{ teamName || $t('CONVERSATION.CARD_CONTEXT_MENU.ASSIGN_TEAM') }}
        </span>
      </div>
      <span
        class="material-symbols-outlined text-[16px] text-gray-600 leading-none"
      >
        expand_more
      </span>
    </button>
    <dropdown-panel
      v-if="isOpenSelector"
      :items="teamsList"
      :selected-items="selectedItems"
      selected-key="id"
      :searchable="searchable"
      :search.sync="search"
      :no-result-text="$t('AGENT_MGMT.MULTI_SELECTOR.SEARCH.NO_RESULTS.TEAM')"
      :placeholder="$t('AGENT_MGMT.MULTI_SELECTOR.SEARCH.PLACEHOLDER.INPUT')"
      @select="onSelectTeam"
    >
      <template #item="{ item }">
        <span>{{ item.name }}</span>
      </template>
    </dropdown-panel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import DropdownPanel from './DropdownPanel.vue';
import teamMixin from 'dashboard/mixins/conversation/teamMixin';

export default {
  components: { DropdownPanel },
  mixins: [clickaway, teamMixin],
  props: {
    searchable: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isOpenSelector: false,
      search: '',
    };
  },
  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
    }),
    teamName() {
      return this.currentChat?.meta?.team?.name || '';
    },
    assignedTeam() {
      return this.currentChat.meta.team;
    },
    selectedItems() {
      return [this.assignedTeam?.id];
    },
  },
  methods: {
    toggleSelector() {
      this.isOpenSelector = !this.isOpenSelector;
    },
    closeSelector() {
      this.isOpenSelector = false;
    },
    onSelectTeam(option) {
      const conversationId = this.currentChat.id;
      const teamId = option.id || 0;
      this.$store.dispatch('setCurrentChatTeam', { option, conversationId });
      this.$store
        .dispatch('assignTeam', { conversationId, teamId })
        .then(() => {
          this.showAlert(this.$t('CONVERSATION.CHANGE_TEAM'));
        });
      this.closeSelector();
    },
  },
};
</script>
